<template>
  <v-container class="pt-6" fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md8>
        <v-card class="elevation-12">
          <v-card-title class="px-9 pt-7">
            Přihlášení
          </v-card-title>

<!--          <v-card-text class="px-9 pt-7">-->
<!--            <span style="color: red">-->
<!--            Některé funkce distribučního portálu mohou být dočasně nedostupné.-->
<!--            Na jejich zprovoznění pracujeme. Děkujeme za pochopení.-->
<!--            </span>-->
<!--          </v-card-text>-->

          <v-card-text v-if="!isProduction">
            <v-radio-group v-model="formType" class="d-inline">
              <v-row>
                <v-col cols="12">
                  <v-radio
                    label="Přihlašovací formulář"
                    value="loginForm"
                  ></v-radio>
                </v-col>
                <v-col cols="12">
                  <v-radio
                    label="Přihlášení elektronickým podpisem"
                    value="sign"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-card-text>

          <LoginForm v-if="formType === 'loginForm'" />
          <Sign v-else :signerUrl="`${baseUrl}uaa/sign`" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Sign from '@/components/Sign.vue';
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'Login',
  components: {
    Sign,
    LoginForm,
  },
  data() {
    return {
      isProduction: process.env.VUE_APP_IS_PRODUCTION,
      formType: !process.env.VUE_APP_IS_PRODUCTION ? 'loginForm' : 'sign',
      baseUrl: process.env.VUE_APP_BACKEND,
    };
  },
};
</script>
